import React, { useCallback, useEffect } from "react";
import verified from "../../../assets/images/verified.png";
import progress from "../../../assets/images/progress.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  Description,
  //   StyledButton,
  Title,
  VerifiedIcon,
  VerifiedText,
  Wrapper,
} from "./style";
import CustomButton from "../../common/button/CustomButton";
import theme from "../../../theme";
import { useDispatch, useSelector } from "react-redux";
import { EMAIL_VERIFY } from "../../../actions/AuthActions";

// -------- Styled Components --------

// -------- Component --------
const VerifyEmail = () => {
  const emailVerifyRes = useSelector((state) => state.auth?.emailVerifyMessage);
  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleVerifyEmail = useCallback((data) => {
    dispatch({ type: EMAIL_VERIFY, payload: data });
  }, [dispatch]);

  useEffect(() => {
    if (token) {
      handleVerifyEmail({ token: token });
    }
  }, [token, handleVerifyEmail]);
  return (
    <Wrapper>
      <Card>
        <Title>Email Verification</Title>
        <VerifiedIcon
          src={emailVerifyRes ? verified : progress}
          alt="verified"
          loading="lazy"
        />
        <VerifiedText>
          {emailVerifyRes ? "Email Verified" : "In Progress"}
        </VerifiedText>
        <Description>
          Your email address has been verified. You can now login to your
          account.
        </Description>
        <CustomButton
          onClick={() => navigate("/login")}
          fontSize={theme.typography.small.fontSize}
          type="submit"
          btnLabel="Login to Account"
          btntype={"primary"}
          height="46px"
        />
      </Card>
    </Wrapper>
  );
};

export default VerifyEmail;
